import React, { useCallback, useRef } from 'react';
import { GoogleMap, Marker, DirectionsRenderer } from '@react-google-maps/api';
import { Customer } from '../types/types';
interface MapViewProps {
  customers: Customer[];
  optimizedRoute: any;
}
const mapContainerStyle = {
  width: '100%',
  height: '100%'
};
const defaultCenter = {
  lat: 41.9028,
  lng: 12.4964 // Rome, Italy default
};
const MapView: React.FC<MapViewProps> = ({
  customers,
  optimizedRoute
}) => {
  const mapRef = useRef<google.maps.Map | null>(null);
  const onMapLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
    // If we have customers, fit the map to show all of them
    if (customers.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      customers.forEach(customer => {
        bounds.extend(customer.location);
      });
      map.fitBounds(bounds);
    }
  }, [customers]);
  return <div className="w-full md:w-2/3 h-screen" data-id="element-124">
      <GoogleMap mapContainerStyle={mapContainerStyle} center={defaultCenter} zoom={10} onLoad={onMapLoad} options={{
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: true
    }} data-id="element-125">
        {/* Render customer markers */}
        {customers.map(customer => <Marker key={customer.id} position={customer.location} title={customer.name} label={{
        text: customer.name.charAt(0),
        color: 'white'
      }} icon={{
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: customer.selected ? '#3B82F6' : '#9CA3AF',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: 'white'
      }} data-id="element-126" />)}
        {/* Render optimized route if available */}
        {optimizedRoute && <DirectionsRenderer directions={optimizedRoute} options={{
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: '#3B82F6',
          strokeWeight: 5,
          strokeOpacity: 0.7
        }
      }} data-id="element-127" />}
      </GoogleMap>
    </div>;
};
export default MapView;